export default "__VITE_ASSET__D7zp9eA4__"